import moment from 'moment'
import resolver from '@/assets/modules/error/resolver'

const DEMO_MEDIA = [
  'https://media-staging.qwilink.com/demo-products/Raspberries.jpg',
  'https://media-staging.qwilink.com/demo-products/Watermelon.jpg',
  'https://media-staging.qwilink.com/demo-products/Pineapple.jpg',
  'https://media-staging.qwilink.com/demo-products/Pomegranate.jpg',
  'https://media-staging.qwilink.com/demo-products/Strawberry.jpg',
  'https://media-staging.qwilink.com/demo-products/Peach.jpg',
  'https://media-staging.qwilink.com/demo-products/Strawberry.jpg',
  'https://media-staging.qwilink.com/demo-products/Pineapple.jpg',
  'https://media-staging.qwilink.com/demo-products/Plums.jpg',
  'https://media-staging.qwilink.com/demo-products/Orange.jpg',
  'https://media-staging.qwilink.com/demo-products/Melon.jpg',
  'https://media-staging.qwilink.com/demo-products/Apricot.jpg',
  'https://media-staging.qwilink.com/demo-products/Grapes.jpg',
  'https://media-staging.qwilink.com/demo-products/Kiwi.jpg',
  'https://media-staging.qwilink.com/demo-products/Cherry.jpg',
  'https://media-staging.qwilink.com/demo-products/Avocado.jpg',
  'https://media-staging.qwilink.com/demo-products/Apple.jpg',
  'https://media-staging.qwilink.com/demo-products/Banana.jpg',
  'https://media-staging.qwilink.com/demo-products/Lemon.jpg',
  'https://media-staging.qwilink.com/demo-products/Blueberries.jpg'
]

const DEMO_TYPES = {
  'twitterTweet': 'twitterProfile',
  'facebookPost': 'facebookPage',
  'pinterestPin': 'pinterestProfile',
  'sqwizArticle': 'sqwizPage',
  'informacijaPost': 'informacijaShop'
}

const DEMO_STATUSES = [
  'ready',
  'published'
]

const DEMO_CAMPAIGN_SATTUSES = [
  'draft',
  'active',
  'paused'
]

const DEMO_CAMPAIGN_TYPES = [
  'productPromotion',
  'dailyDeal',
  'sale'
]

const MPE_TEMPLATE = () => {
  return {
    "id": "tmp-mpe-",
    "type": null,
    "status": null,
    "publishAt": moment().add(-1, 'day').startOf('day').toISOString(),
    "channel": { "id": "tmp-credential-", "type": null, label: 'Channel' },
    "credentials": { "id": "tmp-credential-twitter" },
    "advertisable": { "id": "tmp-adv-", "label": "Demo objava " },
    "campaign": {
      "id": "tmp-c-id",
      "label": "Demo kampanja",
      "type": null,
      "startsAt": moment().add(-1, 'day').startOf('day').toISOString(),
      "expiresAt": moment().add(5, 'day').endOf('day').toISOString(),
      "status": null
    },
    "payload": { "body": "Demo objava ", "media": [{ url: null }] }
  }
}

export default {
  /**
   * Generates mock mpe data
   * @param {Number} n Amount of campaigns we want to build
   * @returns {Array}
   */
  get (n = 8) {
    let rtr = []
    let mpeTypes = Object.keys(DEMO_TYPES)

    let ctr = 0

    for (let i = 0; i < n; i++) {
      let mpeCount = mpeTypes.length
      for (let m = 1; m < mpeCount + 1; m++) {
        ctr ++

        let base = MPE_TEMPLATE()
        base.type = mpeTypes[(ctr) % (mpeTypes.length - 1) ]
        base.id += `${ctr}`
        base.advertisable.id += `${ctr}`
  
        base.status = DEMO_STATUSES[(ctr) % (DEMO_STATUSES.length - 1) ]
        base.channel.type = DEMO_TYPES[mpeTypes[ (ctr)  % (mpeTypes.length)]]
        base.campaign.status = DEMO_CAMPAIGN_SATTUSES[(ctr) % (DEMO_CAMPAIGN_SATTUSES.length - 1) ]
        base.campaign.type = DEMO_CAMPAIGN_TYPES[(ctr) % (DEMO_CAMPAIGN_TYPES.length) ]
        base.campaign.label += ` ${i + 1}`
        base.campaign.id += `-${i}`
        base.payload.media[0].url = DEMO_MEDIA[(ctr) % (DEMO_MEDIA.length) ]
        base.payload[resolver.getMediaFieldName(base.type)] = base.payload.media
  
        rtr.push(base)
      }
    }

    return rtr
  }
}



// WEBPACK FOOTER //
// ./src/mixins/pagination/providers/dummyData/campaignViewer.js